import { useState } from 'react';

import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';
import { AccountHolder } from 'src/models';

import { PhysicalAddressForm } from './PhysicalAddressForm';
import { PhysicalAddressView } from './PhysicalAddressView';

interface OtherAccountHolderPhysicalAddressSectionProps {
  accountHolder: AccountHolder;
}

export const OtherAccountHolderPhysicalAddressSection = ({
  accountHolder,
}: OtherAccountHolderPhysicalAddressSectionProps) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  return (
    <MFormSection
      title='Physical Address'
      onEdit={onEdit}
      isEditable
      isEditMode={isEditMode}
      testId={'physical-address'}>
      {!isEditMode ? (
        <PhysicalAddressView accountHolder={accountHolder} testId={'other'} />
      ) : (
        <PhysicalAddressForm
          accountHolder={accountHolder}
          accountUuid={account?.id}
          isPrimary={false}
          primaryAccountHolderAddress={account?.primaryAccountHolder?.physicalAddress}
          onCancel={onCancel}
        />
      )}
    </MFormSection>
  );
};
